<template>
  <el-form ref="form" :model="form" :rules="rules">
    <el-form-item label="用户权限" prop="role">
      <el-select value="" v-model="form.role" placeholder="用户权限">
        <el-option
          v-for="role of roles"
          :key="role.value"
          :value="role.value"
          :disabled="role.disabled"
        >
          <el-tooltip
            effect="dark"
            :content="role.description"
            placement="right"
          >
            <span class="selection-role">{{ role.label }}</span>
          </el-tooltip>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item required label="创建数量">
      <el-slider v-model="form.num" show-input :min="1" :max="10"> </el-slider>
    </el-form-item>
    <el-form-item>
      <el-button style="width: 100%" type="primary" @click="onSubmit"
        >创建邀请</el-button
      >
    </el-form-item>
    <UserInviteSummary
      v-if="invites.length !== 0"
      :invites="invites"
    ></UserInviteSummary>
  </el-form>
</template>

<script>
import {
  RoleCNMixin,
  ClaimRolePermissionMixin,
  OopsErrorELMessage
} from "@/mixins";
import UserInviteSummary from "@/components/UserInviteSummary";
export default {
  name: "UserRegisterInvite",
  mixins: [RoleCNMixin, ClaimRolePermissionMixin, OopsErrorELMessage],
  components: { UserInviteSummary },
  data() {
    return {
      roles: [],
      rules: {
        role: [{ required: true, message: "权限分配未选择", trigger: "change" }]
      },
      form: {
        role: "",
        num: 1
      },
      invites: []
    };
  },
  mounted() {
    this.roles = [
      {
        label: this.roleLabel("super"),
        value: "super",
        description: "超级管理员",
        disabled: !this.isSuper
      },
      {
        label: this.roleLabel("admin"),
        value: "admin",
        description: "内部开发者权限，资料与版本开发管理人员应分配此权限",
        disabled: !this.isSuperAdmin
      },
      {
        label: this.roleLabel("staff"),
        value: "staff",
        description: "内部员工权限，非开发者内部员工应分配此权限",
        disabled: !this.hasPermRoles(["super", "admin", "staff"])
      }
    ];
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        this.$http
          .post("/api/v1/users/invites", this.form)
          .then(resp => {
            this.invites = [...this.invites, ...resp.data];
          })
          .catch(() => this.oopsError());
      });
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-slider__runway.show-input {
  display: none;
  margin-right: 0;
}
/deep/.el-slider__input.el-input-number {
  float: unset;
}
.selection-role {
  display: block;
}
</style>
